"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@emotion/react");
const styled_1 = __importDefault(require("@emotion/styled"));
const intent_1 = require("../../constants/intent");
const theme_1 = require("../../constants/theme");
const Button_1 = require("../Button");
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
const TOAST_INITIAL_PROPERTIES = {
    opacity: 0,
    transform: 'translateY(-64px)',
};
const toastAppear = (0, react_1.keyframes)({
    from: TOAST_INITIAL_PROPERTIES,
    to: {
        opacity: 1,
        transform: 'translateY(0)',
    },
});
const ToastButton = (0, styled_1.default)(Button_1.Button)((props) => {
    const { backgroundColor, color } = (0, intent_1.getIntentProps)(props.design);
    return {
        backgroundColor,
        border: 'none',
        borderRadius: theme_1.theme.border.radius.normal,
        color,
        cursor: 'pointer',
        fontWeight: theme_1.theme.font.weight.bold,
        paddingBottom: 8,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 8,
        whiteSpace: 'nowrap',
        '&:hover': {
            filter: 'brightness(0.95)',
        },
    };
});
const ToastElement = styled_1.default.div((props) => {
    const { backgroundColor, color } = (0, intent_1.getIntentProps)(props.design);
    return {
        alignItems: 'center',
        animationDuration: `${theme_1.theme.animation.duration}s`,
        animationName: toastAppear,
        animationTimingFunction: theme_1.theme.animation.easing,
        backgroundColor,
        borderRadius: theme_1.theme.border.radius.normal,
        boxShadow: theme_1.theme.boxShadow.elevated,
        color,
        display: 'flex',
        maxWidth: 640,
        paddingLeft: 16,
        position: 'relative',
        transform: 'translateY(0)',
        transition: `opacity ${theme_1.theme.animation.transition}, transform ${theme_1.theme.animation.transition}`,
        pointerEvents: 'auto',
        ...(props.removed ? TOAST_INITIAL_PROPERTIES : {}),
    };
});
const Toast = (props) => {
    const { text: buttonText, ...buttonProps } = props.button ?? {};
    const { iconName } = (0, intent_1.getIntentProps)(props.design);
    return ((0, jsx_runtime_1.jsxs)(ToastElement, { design: props.design, removed: props.removed, children: [(0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: iconName }), (0, jsx_runtime_1.jsx)(Text_1.Text, { px: 3, py: 2, children: props.text }), props.button && ((0, jsx_runtime_1.jsx)(ToastButton, { ...buttonProps, design: props.design, type: "button", children: buttonText })), props.persistent && ((0, jsx_runtime_1.jsx)(ToastButton, { onClick: props.onClose, design: props.design, type: "button", children: (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "XIcon" }) }))] }));
};
exports.Toast = Toast;
